export default __webpack_public_path__ + "static/stefantrinhlogo-9bf07bd08ae0c7cab4b1d39a7051da65.png";